import ReactiveWidget from "lib/reactiveWidget";
import $              from "jquery"
import select2        from "select2"
import "select2/dist/css/select2.min.css"
import "select2-bootstrap-theme/dist/select2-bootstrap.min.css"

import GeocompletedAddress from 'widgets/geocompletedAddress'

class ProposalSearchWidget extends ReactiveWidget {
  bind() {
    this.proposalName = $(this.root.find('#proposal-search'))
    bindProposalSearch.call(this)
    bindAddressLocator.call(this);
  }

  render() {

  }
}

const bindAddressLocator = function() {
  let elem = this.root.find('form')
  new GeocompletedAddress({
    root: elem,
    options: {
      types: ['address'],
      country: 'AU'
    }
  });
};

var bindProposalSearch = function() {
  this.proposalName.select2({
    placeholder: 'Search fee proposal',
    minimumInputLength: 1,
    allowClear: true,
    tags: true,
    theme: 'bootstrap',
    ajax: {
      url: '/select_data/proposals',
      dataType: 'json',
      delay: 250,
      data: (params) => {
        return { by_keyword: params.term }
      },
      processResults: (data, page) => {
        return {
          results: data.collection,
          pagination: data.pagination
        }
      },
      cache: true
    }
  });

  this.proposalName.on('select2:select', (e) => {
    const proposalId = e.target.value
    window.location = `/proposals/${proposalId}`
  });
}

export default ProposalSearchWidget
